import React from "react";
//#region types
import { MinimizedTitledContainerHeaderProps } from "models/propTypes/panelsPropsTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const MinimizedTitledContainerHeader: React.FC<MinimizedTitledContainerHeaderProps> = (props) => {
  const { header, subHeader } = props;

  return (
    <Grid item container direction="column" className={cssExports.titledContainerHeaderMinimized} gap={1}>
      {header ? (
        <Grid item container className={cssExports.titledContainerTitle}>
          {header}
        </Grid>
      ) : (
        <></>
      )}
      {subHeader ? (
        <Grid item container className={cssExports.titledContainerSubTitle}>
          {subHeader}
        </Grid>
      ) : (
        <></>
      )}
    </Grid>
  );
};

export default MinimizedTitledContainerHeader;
